// B2a — 403 page: the route exists but the signed-in role may not open it (distinct from the 404 page).
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import BrandMark from "../components/BrandMark";
import { useAuth } from "../lib/auth";
import { homeRouteFor } from "../lib/roleHome";

export default function AccessDenied() {
  const { user } = useAuth();
  const location = useLocation();
  const attempted = location.state?.attempted || location.pathname;
  const role = (user?.role_key || "").replaceAll("_", " ").toLowerCase();
  return (
    <main className="min-h-screen bg-erf-dark text-erf-cream flex flex-col items-center justify-center p-6" data-testid="access-denied-page">
      <div className="max-w-lg w-full text-center space-y-6">
        <div className="flex justify-center opacity-90"><BrandMark size={96} /></div>
        <div>
          <div className="font-mono text-[11px] uppercase tracking-[0.4em] text-erf-gold">Error · 403</div>
          <h1 className="mt-3 font-display font-bold text-4xl" data-testid="access-denied-title">You don't have access</h1>
          <p className="mt-3 font-nav text-erf-cream/70" data-testid="access-denied-detail">
            Your role{role ? ` (${role})` : ""} can't open <span className="font-mono text-erf-gold break-all">{attempted}</span>.
            Ask the Owner if you need access.
          </p>
        </div>
        <Link to={homeRouteFor(user)} data-testid="access-denied-home-link"
              className="inline-flex items-center justify-center gap-2 min-h-[44px] px-5 rounded-md bg-erf-gold text-erf-dark font-nav font-semibold hover:bg-erf-goldHover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-erf-cream">
          <ShieldOff className="w-4 h-4" aria-hidden="true" /> Go to your home
        </Link>
      </div>
    </main>
  );
}
